import { exhaustiveGuard } from '@/utils/exhaustiveGuard';

import { AndroidBridgeImpl } from './bridge.android';
import { IosBridgeImpl } from './bridge.ios';
import { WebBridgeImpl } from './bridge.web';
import { ClientType } from './types';

const getClientType = (): ClientType => {
  if ('Android' in window) {
    return ClientType.Android;
  } else if ('webkit' in window) {
    return ClientType.iOS;
  } else {
    return ClientType.Web;
  }
};

const bridgeFactory = (clientType: ClientType) => {
  switch (clientType) {
    case ClientType.Android:
      return new AndroidBridgeImpl();
    case ClientType.iOS:
      return new IosBridgeImpl();
    case ClientType.Web:
      return new WebBridgeImpl();
    default:
      // Exhaustive switch
      return exhaustiveGuard(clientType);
  }
};

const getBridgeImplementation = () => {
  const clientType = getClientType();
  return bridgeFactory(clientType);
};

export const bridge = getBridgeImplementation();
